let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hYfE5")).then(() => parcelRequire('2DLxB'));